import React from 'react';
import { Chip, StatusDot } from '@origo/origo-ui';
import { type LayerDraft, type LayerStatus, layerStatus } from './draft';
import styles from './create.module.css';

interface LayerListProps {
    layers: LayerDraft[];
    /** Indeks i layers-listen (lag uten AGOL-match deler agolLayerId -1). */
    selectedIndex: number | null;
    onSelect: (index: number) => void;
}

const STATUS_META: Record<LayerStatus, { variant: 'success' | 'warning' | 'error'; label: string }> = {
    ready: { variant: 'success', label: 'Klar' },
    needsLokalId: { variant: 'error', label: 'Mangler lokalId' },
    unassigned: { variant: 'warning', label: 'Ikke koblet' },
};

/** Venstre panel: liste over objekttyper (lag) med mappingstatus. */
export const LayerList: React.FC<LayerListProps> = ({ layers, selectedIndex, onSelect }) => {
    return (
        <>
            <p className={styles.listLabel}>Objekttyper</p>
            {layers.map((layer, index) => {
                const status = STATUS_META[layerStatus(layer)];
                const active = index === selectedIndex;
                const mappedCount = layer.fields.filter((f) => f.agolFieldName.trim()).length;
                return (
                    <button
                        key={`${layer.featureType}-${layer.geometryKind}-${index}`}
                        type="button"
                        className={`${styles.layerItem} ${active ? styles.layerItemActive : ''}`}
                        onClick={() => onSelect(index)}
                        aria-current={active ? 'true' : undefined}
                    >
                        <span className={styles.layerItemTitle}>
                            <StatusDot variant={status.variant} label={status.label} />
                            {layer.featureType}
                        </span>
                        <span className={styles.layerItemMeta}>
                            <Chip variant="info">{layer.geometryKind}</Chip>
                            <span className={styles.muted}>
                                {mappedCount} av {layer.fields.length} felt
                            </span>
                        </span>
                    </button>
                );
            })}
        </>
    );
};
